import { StrictMode, type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App.tsx';
import './index.css';
import { auth0Config } from './lib/auth0';

function Auth0ProviderWithNavigation({ children }: { children: ReactNode }) {
  const navigate = useNavigate();

  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      cacheLocation="localstorage"
      useRefreshTokens
      onRedirectCallback={(appState) => {
        const returnTo =
          typeof appState?.returnTo === 'string' && appState.returnTo.length > 0
            ? appState.returnTo
            : window.location.pathname + window.location.search + window.location.hash;

        navigate(returnTo, { replace: true });
      }}
      authorizationParams={{
        redirect_uri: auth0Config.redirectUri,
        ...(auth0Config.audience ? { audience: auth0Config.audience } : {}),
        scope: auth0Config.scope,
      }}
    >
      {children}
    </Auth0Provider>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Auth0ProviderWithNavigation>
        <App />
      </Auth0ProviderWithNavigation>
    </BrowserRouter>
  </StrictMode>
);
